import { Member } from 'types/splits.types';

export const sumMembersShares = (entries: Member[]) =>
  (entries || [])
    .reduce((acc: number, cur: Member) => {
      const shareNum = String(cur.share).replace('%', '');
      return cur && cur?.valid !== false && !Number.isNaN(Number(shareNum))
        ? acc + Number(shareNum)
        : acc;
    }, 0)
    .toFixed(2);

export const formatValue = (value: string | number): string => {
  const numberValue = String(value).replace('%', '');
  if (
    numberValue === '' ||
    Number.isNaN(+numberValue) ||
    Number(numberValue) < 0
  ) {
    return '0.00%';
  }
  if (Number(numberValue) > 100) {
    return '100.00%';
  }
  return `${Number(numberValue).toFixed(2)}%`;
};
